<template>
  <div class="client-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de {{ termPlural }}</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
<!--              <b-col cols="auto">-->
<!--                <b-form-input type="text" placeholder="Buscar tipo de lembrete" v-model="searchBy"></b-form-input>-->
<!--              </b-col>-->
              <b-col cols="auto">
                <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar tipo de lembrete</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row>
            <b-col>
              <label class="cj-label">Buscar</label>
              <b-form-input type="text" v-model="searchBy" @keyup.enter="getTransactions(1)"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label">Gênero do termo</label>
              <multiselect v-model="term" :options="termOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="term != ''" @mousedown.prevent.stop="term = ''"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getReminderTypes(1)"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de {{ termPlural }}</p>
                  <p class="title"><small>{{ pagination.total }} {{ termPlural }} cadastrad{{ letter }}s</small></p>
                </div>
              </div>
              <div class="content">

                <div v-if="pagination.lastPage > 1">
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getPeople"></b-pagination>
                  <hr>
                </div>

                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Gênero do termo</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="line-add" v-if="canAdd">
                    <td colspan="4" class="text-center">
                      <router-link tag="a" class="btn btn-block btn-sm btn-add-new" :to="'/'+url+'/'+newTerm"><i class="far fa-plus-circle"></i> Adicionar nov{{ letter}} {{termSingular}}</router-link>
                    </td>
                  </tr>
                    <router-link tag="tr" :to="'/'+url+'/'+reminderType.id" v-for="reminderType in reminderTypes" :key="reminderType.id">
                      <td>{{ reminderType.name }}</td>
                      <td>{{ termOptions.find(term => term.value == reminderType.term).name }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && reminderTypes.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
                <p v-if="searchBy != '' && reminderTypes.length == 0" class="text-center sub-title">A sua busca por {{ termSingular }} com o termo "{{ searchBy }}" não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getReminderTypes"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'tipo de lembrete',
        termPlural: 'tipos de lembrete',
        url: 'tipos-de-lembrete',
        letter: 'o',
        newTerm: 'cadastrar-tipo-de-lembrete',
        module: 'reminder-types',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        reminderTypes: [],

        termOptions: [
          { value: 'f', name: 'Feminino' },
          { value: 'm', name: 'Masculino' }
        ],

        searchBy: '',
        term: ''
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.canSee = true;
      this.canAdd = true;
      this.canEdit = true;
      this.canRemove = true;

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.eventBus.$emit('IS_LOADING', false);
        this.$router.push({ path: '/' });
      } else {
        this.getReminderTypes(this.pagination.currentPage);
      }
    },
    watch: {
      searchBy: function() {
        this.getReminderTypes(1);
      }
    },
    methods: {
      getReminderTypes(page) {
        this.api.getReminderTypes({name: this.searchBy, term: (this.term != null)?this.term.value:null, page: page}).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.reminderTypes = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Reminder Types', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar os tipos de lembrete! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Reminder Types', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.client-list {
      padding: 20px 0;

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 14px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }
          }
        }
      }
    }
  }
</style>
